var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "srmaster"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.createSR
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.merchantList,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.selectedmerchant
    },
    on: {
      "select": _vm.selectMerchant
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.aWBNumberPlaceHolder'),
      "id": "awbnumber"
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bandcamp'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "id": "orderid"
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couriercompany),
      expression: "couriercompany"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "couriercompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couriercompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCourierData), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.couriername
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('srmaster.srStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-check-circle-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.srStatusPlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created"
    }
  }, [_vm._v("Created")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "whreceived"
    }
  }, [_vm._v("WHReceived")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "qcdone"
    }
  }, [_vm._v("QC Done")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin"
    }
  }, [_vm._v("Put Away")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "300px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getSRMasterSearchData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('srmaster.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.receivedWH')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.whReceivedDate')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompany')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.orderItems')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.orderQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.lastModifiedBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.table.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.user_type != 'system_user' && _vm.showSelectClient && _vm.resultCount == 0 && _vm.clientid != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noSRListForClient')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'system_user' && _vm.resultCount == 0 && _vm.clientid != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noSRForClient')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'system_user' && _vm.showSelectClient && _vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'system_user' && _vm.showSelectWarehouse && _vm.warehouseid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'system_user' && _vm.showSelectWarehouse && _vm.resultCount == 0 && _vm.warehouseid != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noSRListForWarehouse')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' && _vm.clientid == '' && _vm.warehouseid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' && _vm.clientid == '' && _vm.warehouseid != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' && _vm.clientid != '' && _vm.warehouseid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' && _vm.clientid != '' && _vm.warehouseid != '' && _vm.resultCount == 0 && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noSRListForClientWarehouse')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type == 'system_user' && _vm.clientid != '' && _vm.warehouseid != '' && _vm.resultCount == 0 && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noSRForSelectedFilter')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSRData), function(data, index) {
    return [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.received_wh))]), _vm._v(" "), (data.merchantname == null) ? _c('td', {
      staticClass: "text-center"
    }) : _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormat(data.modifieddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.couriercompany))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.product_count))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.modifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View SR Products"
      },
      on: {
        "click": function($event) {
          _vm.viewSRPDetailPopUp(data)
        }
      }
    })])]), _vm._v(" "), (data.contentVisible) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": 13
      }
    }, [_c('fieldset', {
      staticStyle: {
        "padding": "10px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-14"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('table', {
      staticClass: "table table-bordered table-hover tbl",
      attrs: {
        "id": "my-table2"
      }
    }, [_c('thead', {
      staticClass: "theader"
    }, [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "tableheader"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', {
      staticClass: "tableheader text-center"
    }, [_vm._v(_vm._s(_vm.$t('srmaster.table.productName')))]), _vm._v(" "), _c('th', {
      staticClass: "tableheader text-center"
    }, [_vm._v(" " + _vm._s(_vm.$t('srmaster.table.clientProductID')))]), _vm._v(" "), _c('th', {
      staticClass: "tableheader text-center"
    }, [_vm._v(_vm._s(_vm.$t('srmaster.table.productID')))]), _vm._v(" "), _c('th', {
      staticClass: "tableheader text-center"
    }, [_vm._v(_vm._s(_vm.$t('srmaster.table.eanCode')))]), _vm._v(" "), _c('th', {
      staticClass: "tableheader text-center"
    }, [_vm._v(_vm._s(_vm.$t('srmaster.table.quantity')))])])]), _vm._v(" "), _c('tbody', [(_vm.resultCountDetail == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "6",
        "align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noProductWithSR')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSRDetailData), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center ",
        attrs: {
          "scope": "row"
        }
      }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.quantity))])])
    })], 2)])])])])])]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.srDetailModal = false
      }
    },
    model: {
      value: (_vm.srDetailModal),
      callback: function($$v) {
        _vm.srDetailModal = $$v
      },
      expression: "srDetailModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.srProductDetails')) + " " + _vm._s(_vm.srid))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSRDetailModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('srmaster.table.productList')))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover tbl",
    attrs: {
      "id": "my-table2"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader text-center"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('srmaster.table.clientProductID')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader text-center"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.productID')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader text-center"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader text-center"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.quantity')))])])]), _vm._v(" "), _c('tbody', [(_vm.resultCountDetail == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noProductWithSR')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSRDetailData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.quantity))])])
  })], 2)]), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.listSRExtraProducts.length > 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('srmaster.table.extraProductsMsg')))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover tbl",
    attrs: {
      "id": "my-table2"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('srmaster.table.productName')))]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('srmaster.table.clientProductID')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('srmaster.table.productID')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('srmaster.table.eanCode')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('srmaster.table.quantity')))])])]), _vm._v(" "), _c('tbody', [(_vm.extraCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.noExtraProductMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSRExtraProducts), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.received_qty))])])
  })], 2)]), _vm._v(" "), _c('br')])])]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showlist == false) ? _c('div', [_c('div', [_c('createsalesreturn', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow,
      "searchflag": _vm.searchflag
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34fcf770", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34fcf770","hasScoped":true}!./src/views/components/sr/srmaster/srmaster.component.html
// module id = 1611
// module chunks = 0